/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PrognoseGruppeTyp } from './PrognoseGruppeTyp';
import {
    PrognoseGruppeTypFromJSON,
    PrognoseGruppeTypFromJSONTyped,
    PrognoseGruppeTypToJSON,
} from './PrognoseGruppeTyp';

/**
 * 
 * @export
 * @interface BerechnungsBaumOhneWurzel
 */
export interface BerechnungsBaumOhneWurzel {
    /**
     * 
     * @type {number}
     * @memberof BerechnungsBaumOhneWurzel
     */
    id: number;
    /**
     * 
     * @type {PrognoseGruppeTyp}
     * @memberof BerechnungsBaumOhneWurzel
     */
    prognoseGruppeTyp: PrognoseGruppeTyp;
    /**
     * 
     * @type {string}
     * @memberof BerechnungsBaumOhneWurzel
     */
    von: string;
    /**
     * 
     * @type {string}
     * @memberof BerechnungsBaumOhneWurzel
     */
    bis: string;
}

/**
 * Check if a given object implements the BerechnungsBaumOhneWurzel interface.
 */
export function instanceOfBerechnungsBaumOhneWurzel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "prognoseGruppeTyp" in value;
    isInstance = isInstance && "von" in value;
    isInstance = isInstance && "bis" in value;

    return isInstance;
}

export function BerechnungsBaumOhneWurzelFromJSON(json: any): BerechnungsBaumOhneWurzel {
    return BerechnungsBaumOhneWurzelFromJSONTyped(json, false);
}

export function BerechnungsBaumOhneWurzelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BerechnungsBaumOhneWurzel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'prognoseGruppeTyp': PrognoseGruppeTypFromJSON(json['prognoseGruppeTyp']),
        'von': json['von'],
        'bis': json['bis'],
    };
}

export function BerechnungsBaumOhneWurzelToJSON(value?: BerechnungsBaumOhneWurzel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'prognoseGruppeTyp': PrognoseGruppeTypToJSON(value.prognoseGruppeTyp),
        'von': value.von,
        'bis': value.bis,
    };
}

